import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  address {
    font: ${font('default', 'normal', '14px/1.5')};
    font-style: normal;

    > a {
      display: block;
    }
  }

  .footer {
    &__contact-info {
      > a {
        font: ${font('default', 'bold', '14px/1.5')};
      }
    }
  }
`
